import React from "react";

const STEPS = [
  {
    n: "01",
    title: "Intake & Privilege",
    body: "All inquiries are routed through an attorney-work-product channel. Case is indexed; no marketing follow-up ever occurs.",
  },
  {
    n: "02",
    title: "Chain Indexing",
    body: "Addresses are ingested against a proprietary deep-chain index spanning BTC, ETH, TRX, LTC, bridged assets, and non-standard indexes: Bad Bank, Whirlpool, hardened paths, CoinJoin.",
  },
  {
    n: "03",
    title: "Forensic Reconstruction",
    body: "Key-derivation feasibility, mixer demixing, and cross-exchange pivots are executed in an isolated, air-gapped environment.",
  },
  {
    n: "04",
    title: "Auditable Chain-of-Custody Deliverable",
    body: "Work-product is hashed, timestamped, and delivered with a technical declaration suitable for private investigation files and family-law discovery.",
  },
];

export default function Methodology() {
  return (
    <section id="methodology" className="paper-section relative" data-testid="methodology-section">
      <div className="absolute inset-0 grid-bg opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 lg:col-span-4">
            <div className="mono-label-paper mb-6">§ 03 · METHODOLOGY</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.1]">
              A defensible protocol. Every retention.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-7 lg:col-start-6 pt-8">
            <p className="text-paperink/75 text-base leading-relaxed">
              The protocol below governs every engagement — from a privileged feasibility memorandum
              through to an auditable technical declaration. Deviation from protocol is the single
              largest source of inadmissible evidence in crypto forensics.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-paperline border border-paperline">
          {STEPS.map((s) => (
            <div key={s.n} className="bg-paper p-10" data-testid={`method-step-${s.n}`}>
              <div className="flex items-start justify-between border-b border-paperline pb-6">
                <span className="font-serif-display text-5xl">{s.n}</span>
                <span className="mono-label-paper">STEP {s.n}</span>
              </div>
              <h3 className="font-serif-display text-2xl mt-6">{s.title}</h3>
              <p className="text-paperink/75 text-sm mt-4 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
